import React from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import OverViewAdvice from './OverViewAdvice';
import AboutMeAdvice from './AboutMeAdvice';
import EducationAdvice from './EducationAdvice';
import WorkExperienceAdvice from './WorkExperienceAdvice';
import ProjectAdvice from './ProjectAdvice';
import SvgMe from './SvgMe';
import SvgOverView from './SvgOverView';
import SvgExperience from './SvgExperience';
import SvgProject from './SvgProject';
import SvgEducation from './SvgEducation';
import { trackClickEvent } from '@/utils/site-track';

export const RESUME_ADVICE_ID = 'resume-advice';
export const OVERVIEW_EN = 'overview';
export const ABOUT_ME_EN = 'about_me';
export const EDUCATION_EN = 'education_experience';
export const WORK_EXPERIENCE_EN = 'work_experience';
export const PROJECT_EXPERIENCE_EN = 'project_experience';

const ADVICE_MENU = [
  {
    title: '概览',
    en: OVERVIEW_EN,
    intro: '展示简历',
    icon: <SvgOverView />,
    node: <OverViewAdvice />,
  },
  {
    title: '个人总结',
    en: ABOUT_ME_EN,
    intro: '在个人总结中呈现职业脉络',
    icon: <SvgMe />,
    node: <AboutMeAdvice />,
  },
  {
    title: '教育经历',
    en: EDUCATION_EN,
    intro: '在教育经历中凸显优势',
    icon: <SvgEducation />,
    node: <EducationAdvice />,
  },
  {
    title: '工作经历',
    en: WORK_EXPERIENCE_EN,
    intro: '在工作经历中强化职业形象',
    icon: <SvgExperience />,
    node: <WorkExperienceAdvice />,
  },
  {
    title: '项目经历',
    en: PROJECT_EXPERIENCE_EN,
    intro: '在项目经历中展示个人能力',
    icon: <SvgProject />,
    node: <ProjectAdvice />,
  },
];

const ResumeAdvice = React.forwardRef((props: { showContent: string }, ref) => {
  const { showContent } = props;

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  React.useImperativeHandle(ref, () => ({
    setSelectedIndex,
  }));

  return (
    <section
      id={RESUME_ADVICE_ID}
      className={`absolute inset-0 transition-all duration-200 pb-12 ${showContent === RESUME_ADVICE_ID ? 'visible opacity-100' : 'invisible opacity-0'} h-full flex flex-col overflow-y-scroll overflow-x-hidden`}
    >
      <div className="mt-5 px-4 shrink-0 sticky top-0 bg-white/80 backdrop-blur z-10">
        <Tabs
          value={selectedIndex}
          onChange={(event, value) => {
            trackClickEvent(event);
            setSelectedIndex(value);
          }}
          TabIndicatorProps={{ className: '!hidden' }}
        >
          {ADVICE_MENU.map(({ title, en, icon }, index) => (
            <Tab
              key={title + index}
              className="!px-5 !py-3 !text-sm !text-black/65 !min-h-9 !border !border-solid !border-black/10 !rounded-lg [&_.MuiTab-iconWrapper]:mr-1 [&:not(:last-child)]:mr-2 [&.Mui-selected]:!text-web-blue-500 [&.Mui-selected]:font-semibold [&.Mui-selected]:bg-white hover:bg-blue-50"
              value={index}
              label={title}
              icon={icon}
              iconPosition="start"
              disableRipple={true}
              data-event={`resume_advice_${en}-tab`}
              data-ele-id={`${en}_${title}`}
              data-ele-group="resume-advice_tab"
            />
          ))}
        </Tabs>
      </div>
      <div className="grow pb-8 mt-2 text-sm">
        {ADVICE_MENU.map(({ title, node }, index) => (
          <div
            key={index + title}
            className={index === selectedIndex ? 'block' : 'hidden'}
          >
            {node}
          </div>
        ))}
      </div>
    </section>
  );
});

export default ResumeAdvice;
